export const SET_PAGES = "SET_PAGES";

export const SELECT_PAGE = "SELECT_PAGE";

export const ADD_PAGE = "ADD_PAGE";

export const UPDATE_PAGE = "UPDATE_PAGE";

export const DELETE_PAGE = "DELETE_PAGE";

export const REORDER_PAGE = "REORDER_PAGE";

export const TOGGLE_ADD_NEW_PAGE_DIALOG = "TOGGLE_ADD_NEW_PAGE_DIALOG";

export const TOGGLE_EDIT_PAGE_DIALOG = "TOGGLE_EDIT_PAGE_DIALOG";

export const TOGGLE_DELETE_PAGE_DIALOG = "TOGGLE_DELETE_PAGE_DIALOG";

export const TOGGLE_CONTEXT_MENU = "TOGGLE_CONTEXT_MENU";

export const UPDATE_PAGE_PROPERTIES = "UPDATE_PAGE_PROPERTIES";

export const UPDATE_PAGE_COMPONENT = "UPDATE_PAGE_COMPONENT";

export const ADD_COMPONENT_TO_PAGE = "ADD_COMPONENT_TO_PAGE";

export const ADD_COMPONENT_TO_FLATLIST = "ADD_COMPONENT_TO_FLATLIST";

export const DELETE_COMPONENT = "DELETE_COMPONENT";